module.exports = __webpack_public_path__ + "files/f699c0b6a948f3bac132ea374e696557.png";